import { ControlOutlined, ExperimentOutlined, FolderOpenOutlined, FundViewOutlined, SearchOutlined } from '@ant-design/icons';
import { Card, Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { CardLink, FlexCol } from '../components/common/common';
import { FC } from 'react';
import { isBleApp, useMediaQuery } from '../utils/helpers/utils';
import { DEVICE_ROUTE, RECORDS_MANAGEMENT_ROUTE, SENSE_ROUTE } from '../config/routes';

export const HomePage: FC = () => {
  const isMobile = useMediaQuery();
  const fontSize = 40;

  return (
    <FlexCol
      style={{
        justifyContent: 'space-evenly',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Row>
        <FlexCol
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography.Title
            level={2}
            style={{
              fontSize,
              marginBottom: 0,
              textAlign: 'center',
            }}
          >
            Welcome to Olfast webapp
          </Typography.Title>
          <Typography.Text
            style={{
              fontSize: 20,
              textAlign: 'center',
            }}
          >
            <>Make sure to connect your device to your computer.</>
          </Typography.Text>
        </FlexCol>
      </Row>
      <Row gutter={[10, 10]} align="stretch">
        <Col xs={24} md={8}>
          <CardLink to={DEVICE_ROUTE.path} title="Manage sensor" icon={<ControlOutlined style={{ fontSize }} />} />
        </Col>
        <Col xs={24} md={8}>
          <CardLink to={SENSE_ROUTE.path} title="Live sensor data" icon={<FundViewOutlined style={{ fontSize }} />} />
        </Col>
        <Col xs={24} md={8}>
          <CardLink to={RECORDS_MANAGEMENT_ROUTE.path} title="Manage records" icon={<FolderOpenOutlined style={{ fontSize }} />} />
        </Col>
      </Row>
    </FlexCol>
  );
};
